import LeftSidebar from "components/navigations/LeftSidebar";
import RightSidebar from "components/navigations/RightSidebar";
import Topbar from "components/navigations/Topbar";
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const Layout = ({ children }) => {
  return (
    <div>
      <Topbar />
      <div className="flex ">
        <LeftSidebar />
        <MainContainer className="  flex-[2] bg-gray-900 ">
          {children}
        </MainContainer>
        <RightSidebar />
      </div>
    </div>
  );
};

export default Layout;

const MainContainer = styled.div`
  width: 100%;
`;
